import { createSlice } from '@reduxjs/toolkit';
// import { calculateShippingCharged } from './thunkAction'; // adjust path if needed
import { calculateShippingCharged } from './ThunkAction';
import { iGenericResponse } from '@/customTypes/CommonServiceTypes';
import { iStateMessage } from '@/customTypes/GenericReduxTypes';

interface FormState {
  loading: boolean;
  shippingData: any | null;
  message: string | null;
  error: iStateMessage | null;
}

const initialState: FormState = {
  loading: false,
  shippingData: null,
  message: null,
  error: null,
};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    clearShippingState: (state) => {
      state.loading = false;
      state.shippingData = null;
      state.message = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(calculateShippingCharged.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = null;
      })
      .addCase(calculateShippingCharged.fulfilled, (state, action) => {
        state.loading = false;
        state.shippingData = action.payload?.data || null;
        
        state.message = action.payload?.message || null;
      })
      .addCase(calculateShippingCharged.rejected, (state, action) => {
        state.loading = false;
        state.shippingData = null;
        state.message = null;
        // @ts-expect-error
        state.error = action.payload || { message: 'Unknown error occurred' };
      });
  },
});

export const { clearShippingState } = formSlice.actions;
export default formSlice.reducer;
